import React from 'react'
import { Button, Icon, Display } from '../'
import styles from './Message.module.css'
import classNames from 'classnames/bind'

const cx = classNames.bind(styles)

const Message = props => {
  const icon = props.success ? 'check' : props.error ? 'close' : 'drag'

  return (
    <div className={cx({
      'message-el': true,
      base: true,
      success: props.success,
      error: props.error,
      vertical: props.vertical,
    })}>
      <div>
        <div className={`message-icon-el ${styles.icon}`}>
          <Icon name={icon} />
        </div>
        <div className={`message-text-el ${styles.message}`}>
          {props.children}
        </div>
        <div className={`message-button-el`}>
          <Display if={props.button}>
            <Button {...props.button} />
          </Display>
        </div>
      </div>
    </div>
  )
}

export default Message
